import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { signIn } from "@/lib/auth-client";

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = new URLSearchParams(location.search).get("redirect") ?? "/dashboard";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = await signIn.email({ email, password });
    setLoading(false);
    if (result.error) {
      setError(result.error.message ?? "Invalid credentials");
    } else {
      navigate(redirectTo);
    }
  }

  return (
    <div className="min-h-full flex">
      {/* Left branding panel */}
      <div className="hidden sm:flex w-64 flex-shrink-0 bg-slate-800 flex-col items-start p-6">
        <div className="flex items-center gap-3">
          <img src="/logo.jpg" alt="Fudge Log" className="w-10 h-10 rounded object-cover flex-shrink-0" />
          <span className="text-base font-semibold text-white">Fudge Log</span>
        </div>
        <div className="mt-auto">
          <p className="text-xs text-slate-500">Temporary change tracking</p>
        </div>
      </div>

      {/* Right form panel */}
      <div className="flex-1 flex items-center justify-center bg-slate-100 p-6">
        <div className="w-full max-w-sm">
          {/* Mobile branding — shown only on small screens */}
          <div className="flex items-center justify-center gap-3 mb-6 sm:hidden">
            <img src="/logo.jpg" alt="Fudge Log" className="w-10 h-10 rounded object-cover" />
            <span className="text-lg font-semibold text-slate-800">Fudge Log</span>
          </div>
          <div className="bg-white rounded-lg border border-slate-200 shadow-sm p-8">
            <div className="mb-6">
              <h1 className="text-xl font-semibold text-slate-900">Sign in</h1>
              <p className="text-sm text-slate-500 mt-1">Temporary change tracking</p>
            </div>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Email</label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-3 py-2 border border-slate-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Password</label>
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-3 py-2 border border-slate-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              {error && <p className="text-sm text-red-600">{error}</p>}
              <button
                type="submit"
                disabled={loading}
                className="w-full py-2 px-4 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 disabled:opacity-50"
              >
                {loading ? "Signing in…" : "Sign in"}
              </button>
            </form>
            <p className="mt-4 text-sm text-slate-500 text-center">
              No account?{" "}
              <Link to="/register" className="text-blue-600 hover:underline">Register</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
